import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, ComplainSearch_GroupBy, AuthActionCodes, JobSearch_Compact_Mode } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, ListResponse } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { GenericMaster, GenericMaster_String, LocationLookup, CallDescriptionLookup, CallCategoryLookup, VIP } from '../../Models/GlobalEntities';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'JobSearchResult_Compact',
    templateUrl: './JobSearchResult_Compact.html'
})

export class JobSearchResult_Compact extends BaseComponent implements OnInit, OnDestroy {
    _RequestModel: ComplainSearch;
    Model: ListResponse;
    DateFormat: string;
    _CallStatus = CallStatuses;
    @Input() Mode: JobSearch_Compact_Mode = JobSearch_Compact_Mode.Location;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {
        //window.clearInterval(this.Timer);
        //this.complainService.JobConsoleRefreshEvent.;
    }


    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        // this.RequestModel.Properties.push(this.masterService.LoggedInUserData.PropertyId);
    }

    @Input("RequestModel") set RequestModel(Model: ComplainSearch) {
        //console.info(Model);
        this._RequestModel = Model;
    }

    get RequestModel(): ComplainSearch {
        return this._RequestModel;
    }

    @Input() Show(): void {
        this.SetData();
    }

    SetData(): void {
        if (this.RequestModel == null)
            return;

        //this.complainService.SelectedJob = null;

        this.RequestModel.PageSize = 10;

        this.IsSubmitting = true;

        this.complainService.Complain_Search(this.RequestModel).then(data => {
            this.Model = data;
            this.RequestModel.PageNumber = data.CurrentPage;
            this.IsSubmitting = false;
        }).catch(reason => {
            this.IsSubmitting = false;
        })
    }

    onRowSelected(row: any): void {
        if (row == null) {
            this.complainService.SelectedJob = null;
            this.complainService.increasePopupOpacity = false;
            return;
        }

        if (this.complainService.SelectedJob != null && this.complainService.SelectedJob.ComplainId == row.ComplainId) {
            this.complainService.SelectedJob = null;
            this.complainService.increasePopupOpacity = false; 
    }
        else { 
            this.complainService.SelectedJob = row;
            this.complainService.increasePopupOpacity = true;
        }        
    }

    onPageChange(): void {
        this.SetData();
    }

    onFilter(row: GenericMaster_String): void {
        this.RequestModel.OrderBy = row.Id;
        this.SetData();
    }
}
